import { render, staticRenderFns } from "./AvatarProfile.vue?vue&type=template&id=595d347c"
import script from "./AvatarProfile.vue?vue&type=script&lang=js"
export * from "./AvatarProfile.vue?vue&type=script&lang=js"
import style0 from "./AvatarProfile.vue?vue&type=style&index=0&id=595d347c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports